module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"qr-code-instructions":"Llevá tus reciclables a tu punto Recyco más cerca y mostrales este código para conseguir monedas","see-conversion-table":"Ver tabla de conversión"},"en":{"qr-code-instructions":"Take your reciclables to your nearest Recyco station and show the operator this QR code to receive your RecyCoins","see-conversion-table":"See conversion table"}}')
  delete Component.options._Ctor
}
